import i18n from "@/libs/i18n";

export default [
  {
    get header() {
      return i18n.t("office.senior-house-office");
    },
    permission: "get-patientCard",
    role: ["SeniorHouseOffice", "seniorHouseOffice"],
  },
  {
    get title() {
      return i18n.t("common.patients");
    },
    route: "senior-house-office",
    icon: "PlusSquareIcon",
    permission: "get-patientCard",
    role: ["SeniorHouseOffice", "seniorHouseOffice"],
  },
  // {
  //   get title() {
  //     return i18n.t("bloodBank.blood-compatibility");
  //   },
  //   route: "blood-compatibility",
  //   icon: "PlusSquareIcon",
  //   permission: "get-patientCard",
  //   role: "SeniorHouseOffice",
  // },
  {
    get title() {
      return i18n.t("office.sho-blood-transfusions");
    },
    route: "blood-transfusions-sho",
    icon: "HomeIcon",
    permission: "get-patientCard",
    role: ["SeniorHouseOffice", "seniorHouseOffice"],
  },
];
